import { useTranslation } from "react-i18next";
import _ from "lodash";
import moment from "moment";
import { useQuery, useSubscription } from "@apollo/react-hooks";
import {
  MY_CAFETERIA_GET_CURRENT_STATEMENT_ITEMS,
  MY_CAFETERIA_SUBSCRIPTION,
} from "my-cafeteria/graphql";
import { useOcPolling } from "oc/hooks";
import parseJdDate from "oc/utils/parse-jd-date";

export const useMyCafeteriaCurrentStatementItems = ({
  contractCode,
}: {
  contractCode: string;
}) => {
  const { t } = useTranslation();

  const { data, loading, error, refetch } = useQuery(
    MY_CAFETERIA_GET_CURRENT_STATEMENT_ITEMS,
    {
      skip: !contractCode,
      fetchPolicy: "cache-and-network",
      pollInterval: useOcPolling(1000 * 60),
      variables: { contractCode },
    },
  );

  const { error: subscriptionError } = useSubscription(
    MY_CAFETERIA_SUBSCRIPTION,
    {
      skip: !contractCode,
      onData: () => {
        refetch();
      },
      onError: (err) => {
        console.log("error", err);
      },
    },
  );

  /** Manipulationg data */
  let parsedData = [];
  try {
    parsedData = data?.getCurrentCafeteriaStatementItems?.map(
      (item: any, index: number) => {
        let newItem = _.cloneDeep(item);
        let isPlan = item.plan
          ? t("MY_CAFETERIA_PLAN")
          : t("MY_CAFETERIA_FACT");
        newItem.index = index;
        newItem.startDate = moment(parseJdDate(newItem.startDate)).format("MM");
        newItem.originalStartDate = item.startDate;
        newItem.endDate = moment(parseJdDate(newItem.endDate)).format("MM");
        newItem.originalEndDate = item.endDate;
        newItem.months = `${newItem.startDate} - ${newItem.endDate}`;
        let numberOfMonths = +newItem.endDate - +newItem.startDate + 1;
        newItem.numberOfMonths = numberOfMonths;
        newItem.valueOfBenefit = item.cost;
        newItem.benefit = item.menuItem.name;
        newItem.planable = item.menuItem.planable;
        newItem.origin = `${item.origin} - ${isPlan}`;
        newItem.cost = item.cost - item.amount * numberOfMonths;
        newItem.amount = item?.amount * numberOfMonths;
        return newItem;
      },
    );
  } catch (error) {
    console.log(error);
  }

  return {
    data: parsedData,
    loading: loading && !data,
    error: error || subscriptionError,
  };
};

export default useMyCafeteriaCurrentStatementItems;
